import { HttpRepository } from "./HttpRepository";
import { AuthenticatedHttpClient } from "./AuthenticatedHttpClient";

export class AuthenticatedRepository extends HttpRepository {
  public constructor(getToken: () => string) {
    super(new AuthenticatedHttpClient(getToken));
  }

  protected get token(): string {
    return (this._client as AuthenticatedHttpClient).token;
  }
}
